import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';

export function sendFileBrowserMessage(
  socket: WebSocket,
  e2ee: CliE2eeRuntime | undefined,
  payload: Record<string, unknown>,
): void {
  sendWsMessage(socket, e2ee ? e2ee.encryptFields(payload, ['entries', 'content', 'totalLines', 'size', 'lineOffset']) : payload);
}
